module.exports = __webpack_public_path__ + "static/media/marked-tag.8a922bac.svg";